import { View } from "binder"
import { MachineModelEditorViewModel } from "./machineModelEditor-viewModel"
import { MachineTypeSelectorViewModel } from "../machineTypeSelector-viewModel";

export class MachinelModelEditorView extends View<MachineModelEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-926AE4DC-639A-4127-A536-E2F4C95FA76A"
    }
    loadHtml(): string {
        let element = require('./machineModelEditor.html').default;
        let style = require('./machineModelEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set machineTypeId(v: string) { this._machineTypeId = v; } public get machineTypeId(): string { return this._machineTypeId; } private _machineTypeId: string;
    public set machineTypeSelector(v: MachineTypeSelectorViewModel) { this._machineTypeSelector = v; } public get machineTypeSelector(): MachineTypeSelectorViewModel { return this._machineTypeSelector; } private _machineTypeSelector: MachineTypeSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
